import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TApplicationUserRelation, TApplicationUserRelationResponse, adaptApplicationUserRelationFromResponse } from '../../types';
import { BACKEND_ADMIN_APPLICATION_USER_RELATION } from '../../backend-paths';


export const applicationUserRelationReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ADMIN_APPLICATION_USER_RELATION}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_APPLICATION_USER_RELATION}/${payload}`;

		return HttpService.get<TApplicationUserRelationResponse>(path).then(result => {
			return adaptApplicationUserRelationFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TApplicationUserRelation> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const applicationUserRelationReadSlice = createSlice({
	name: 'applicationUserRelationReadSlice',
	initialState,
	reducers: {
		setApplicationUserRelationRead(state, action: PayloadAction<TApplicationUserRelation>) {
			state.item = action.payload;
		},

		clearApplicationUserRelationRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[applicationUserRelationReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[applicationUserRelationReadGetApi.fulfilled.type]: (state, action: PayloadAction<TApplicationUserRelation>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[applicationUserRelationReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useApplicationUserRelationReadSelector = () => useAppSelector(state => state[applicationUserRelationReadSlice.name]);

export const { clearApplicationUserRelationRead, setApplicationUserRelationRead } = applicationUserRelationReadSlice.actions;
